import { getStartOfMonth, getEndOfTheDay } from '../utils/dateUtils';

export const dashboardPageFilters: Record<string, string[]> = {
  startDate: [getStartOfMonth().toISOString()],
  endDate: [],
  period: ['monthly'],
};

export const alertsPageFilters: Record<string, string[]> = {
  startDate: [getStartOfMonth().toISOString()],
  endDate: [],
  period: ['monthly'],
  sortBy: ['eventDate_DESC'],
  riskLevel: ['medium', 'urgent'],
  isThumbnail: ['null'],
  isValid: ['true'],
  sensor: [],
  name: [],
};

export const devicesPageFilters: Record<string, string[]> = {
  isOnline: ['null'],
  'vehicle._id': ['null'],
  sortBy: ['isOnline_ASC'],
};

export const deviceDetailsPageFilters: Record<string, string[]> = {
  startDate: [getStartOfMonth().toISOString()],
  endDate: [],
  period: ['monthly'],
};

export const tripsPageFilters: Record<string, string[]> = {
  startDate: ['1970-01-01T00:00:00.000Z'],
  endDate: [],
  period: ['custom'],
  sortBy: ['startAt_DESC'],
  isMergedTrip: [],
};

export const driversPageFilters: Record<string, string[]> = {
  startDate: [getStartOfMonth().toISOString()],
  endDate: [],
  period: ['all'],
  sortBy: ['firstName_ASC'],
  'vehicle._id': ['null'],
};

export const driverDetailsPageFilters: Record<string, string[]> = {
  startDate: [getStartOfMonth().toISOString()],
  endDate: [getEndOfTheDay().toISOString()],
  period: ['monthly'],
};

export const vehiclesPageFilters: Record<string, string[]> = {
  startDate: [getStartOfMonth().toISOString()],
  endDate: [],
  category: ['null'],
  driverId: ['null'],
  status: ['null'],
  sortBy: ['licensePlateNumber_ASC'],
  period: ['all'],
};

export const vehicleDetailsPageFilters: Record<string, string[]> = {
  startDate: [getStartOfMonth().toISOString()],
  endDate: [getEndOfTheDay().toISOString()],
  period: ['monthly'],
};

export const videosPageFilters: Record<string, string[]> = {
  sortBy: ['updatedAt_DESC'],
  startDate: [getStartOfMonth().toISOString()],
  endDate: [],
  period: ['monthly'],
  alertId: ['manual'],
  status: ['null'],
  cameraId: ['null'],
};

export const usersPageFilters: Record<string, string[]> = {
  role: ['null'],
  sortBy: ['name_ASC'],
};

export const audioSchemasPageFilters: Record<string, string[]> = {
  sortBy: ['name_ASC'],
};

export const groupsPageFilters: Record<string, string[]> = {
  sortBy: ['name_ASC'],
};
